<template>
    <div class="videos">
        <el-dialog
            title="编辑视频"
            :visible.sync="showvideospicker"
            width="1100px"
            :before-close="close"
            append-to-body>
            
            <div class="table-box">
                <transition-group name="flip-list" tag="div">
                    <div class="img-box" draggable="true" v-for="(item, ind) in videos" :key="ind" @dragstart="dranstart(item)" @dragend="dragend" @dragenter="dragenter(item)">
                        <el-button class="del-btn" type="danger" size="mini" icon="el-icon-delete" circle @click.stop="delvideo(item, ind)"></el-button>
                        <el-image class="img" :src="item.thumbnail" fit="scale-down" :lazy="true"></el-image>
                    </div>
                </transition-group>
                <el-button type="primary" size="default" @click="confirm">保存</el-button>
            </div>

            <el-form :model="form" ref="form" :rules="rules" label-width="80px" :inline="false" size="mini">
                <el-form-item label="缩略图">
                    <el-upload
                        class="avatar-uploader"
                        action="/api/Upload/uploadFile/"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img v-if="form.thumbnail" :src="form.thumbnail" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="视频地址">
                    <el-input v-model="form.path" placeholder="请填写视频地址，只支持腾讯视频，其他平台不能播放" clearable maxlength="200" @blur="formatepath"></el-input>
                </el-form-item>
                <el-form-item label="提取参数">
                    <p class="text">播放地址：{{form.url}}</p>
                    <p class="text">视频编号：{{form.vid}}</p>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input v-model="form.title" placeholder="请填写视频标题" clearable maxlength="30"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="add">添加视频</el-button>
                </el-form-item>
            </el-form>
            
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'Videos',
    data() {
        return {
            videos: [],
            form: {
                thumbnail: '',
                path: '',
                title: '',
                url: '',
                vid: '',
            },
            rules: {

            },
            oldNum: 0,
            newNum: 0,
        }
    },
    mounted () {
        this.getvideosList();
    },
    props: {
        acid: {
            type: String,
            default: '',
        },
    },
    computed: {
        showvideospicker: {
            get() {
                return this.$store.getters.getshowvideospicker;
            },
            set(val) {
                this.$store.commit('setshowvideospicker', val);
            },
        }
    },
    methods: {
        formatepath() {
            // var xx = 'https://v.qq.com/x/cover/zbd89oiwbrhi0sw/b0036d41j19.html';
            // var x = '<iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=b0036d41j19" allowFullScreen="true"></iframe>';
            // var xxx = 'https://v.qq.com/x/page/d3244hkj460.html';
            var path = this.form.path;

            var str = 'https://v.qq.com/txp/iframe/player.html?vid=';
            var url, vid;
            if (path.indexOf('/x/cover/')>-1){
                var str2 = path.slice(25, 200);
                var arr = str2.split('/');
                str2 = arr[1];
                var index = str2.indexOf('.html');
                vid = str2.slice(0, index);
                url = str+vid;
                
            }

            if (path.indexOf('<iframe')>-1){
                var index1 = path.indexOf('src=')
                var index2 = path.indexOf('allowFullScreen="')
                url = path.slice(index1*1+5, index2*1-2);
                var index3 = url.indexOf('vid=')
                vid = url.slice(index3*1+4, 200);
            }

            if (path.indexOf('x/page/')>-1){
                var index1 = path.indexOf('x/page/');
                var str2 = path.slice(index1*1+7, 200);
                var index2 = str2.indexOf('.html');
                vid = str2.slice(0, index2);
                url = str+vid;
            }

            this.form.url = url;
            this.form.vid = vid;
        },
        add() {
            if (!this.form.url||!this.form.vid) this.formatepath();
            this.videos.push(this.form);
            this.form = {
                thumbnail: '',
                path: '',
                title: '',
                url: '',
                vid: '',
            };
        },
        confirm() {
            var params = {
                id: this.acid,
                videos: JSON.stringify(this.videos)
            }
            this.$api.setActivityVideos(params).then(
                data=>{
                    this.$message.success(data);
                    this.$store.commit('setshowvideospicker', false);
                }
            )
        },
        getvideosList() {
            var params = {
                id: this.acid,
            }
            this.$api.getActivityVideosList(params).then(
                data=>{
                    this.videos = data;
                }
            )
        },
        delvideo(item, index) {
            this.$confirm("是否确定删除").then(
                confirm=>{
                    this.videos.splice(index, 1);
                },
                cancel=>{}
            )
        },
        close() {
            this.$confirm('编辑内容未保存是否确定关闭?')
                .then(_=>{
                    this.$store.commit('setshowvideospicker', false);
                })
                .catch(_=>{})
        },
        dranstart(value) {
            this.oldNum = value;
        },
        dragend: function(value) {
            if (this.oldNum != this.newNum) {
                let oldIndex = this.videos.indexOf(this.oldNum);
                let newIndex = this.videos.indexOf(this.newNum);
                let newItems = [...this.videos];
                // 删除老的节点
                newItems.splice(oldIndex, 1); 
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldNum);
                // this.items一改变，transition-group就起了作用
                this.videos = [...newItems];
            }
        },
        dragenter: function(value) {
            this.newNum = value;
        },
        handleAvatarSuccess(res) {
            let {data, msg} = res;
            if (data){
                this.$message.success(msg);
                this.form.thumbnail = data;
                this.$forceUpdate()
            } else {
                this.$message.error(msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG  = file.type === 'image/png';
            // const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG&&!isPNG) {
                this.$message.error('只能上传图片，不能上传其他文件!');
            }
            // if (!isLt2M) {
            //     this.$message.error('上传的图片大小不能超过 1MB!');
            // }

            return isJPG||isPNG;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner{
    height: 200px;
}
::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 350px;
    height: 176px;
    line-height: 176px;
    text-align: center;
}
.avatar {
    width: 350px;
    height: 176px;
    display: block;
}
.head{
    .title{
        line-height: 28px;
    }
}
.table-box{
    margin-top: 10px;
}
.table-box{
    padding-bottom: 20px;
    margin-bottom: 20px;
    overflow: hidden;
    border-bottom: 1px solid #eee;
}
.img-box{
    width: 233px;
    height: 160px;
    border: 1px dashed #eee;
    float: left;
    box-sizing: border-box;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    .del-btn{
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
    }
    .edit-btn{
        position: absolute;
        top: 36px;
        right: 0;
        z-index: 10;
    }
    .img{
        width: 230px;
        height: 158px;
        vertical-align: middle;
    }
}
.upl-warp{
    margin-top: 10px;
    position: relative;
    .sav-btn{
        position: absolute;
        left: 400px;
        top: 10px;
    }
}
</style>